// extracted by mini-css-extract-plugin
export default {"btnWrap":"selected-work_btnWrap__8n1Jd","viewBtn":"selected-work_viewBtn__swNqd"};